const guia = {
  hero: {
    badge: 'Market Intelligence',
    title1: 'Neighborhood & City',
    title2: ' Price Guide 2025',
    description: 'Understand local market values with average price per m² / sq ft, year-over-year trends, and neighborhood scores across Miami (Florida, USA), São Paulo, and Brasília.',
    statCities: '3 Cities',
    statNeighborhoods: '20 Neighborhoods',
    statTrends: '5-Year Trends',
    statAi: 'AI-Generated Data',
  },
  pulse: {
    title: 'Market Pulse',
    subtitle: '3 markets · Latest updates',
    updated: 'Updated on',
    viewGuide: 'View guide',
    recentUpdates: 'recent updates',
    badgePrices: 'Prices',
    badgeTrend: 'Trend',
    disclaimer: '<0>Educational Purposes Only — AI-Generated Data Disclaimer:</0> The average price per m² / sq ft figures, year-over-year growth rates, and neighborhood scores presented on this page are AI-generated estimates compiled from publicly available market reports, real estate indices (FipeZAP, ZAP Imóveis, CondoBlackBook), and third-party sources as of 2024–2025. This data may be outdated, incomplete, or inaccurate. It is intended solely for general educational and informational purposes and does not constitute financial, investment, or real estate advice. <1>Carvalho\'s Imobiliária assumes no liability for any errors, omissions, or decisions made based on this information.</1> Always consult a licensed real estate professional and conduct independent due diligence before making any investment decision.',
  },
  citySelector: {
    title: 'Select a City',
    subtitle: 'Click to explore neighborhoods and price data',
    selected: 'Selected',
    listings: 'listings',
    avgPrice: 'Avg. price',
    yoyGrowth: 'YoY growth',
    viewFullGuide: 'View full guide for',
  },
  miamiDetail: {
    description: 'Miami is one of the most dynamic luxury real estate markets in the world, attracting international investors and ultra-high-net-worth buyers. The city combines tropical lifestyle, world-class amenities, and strong appreciation potential. In 2025, luxury condo prices surpassed $1,000/sq ft on average for the first time in history.',
    avgPrice: 'Avg. Price',
    yoyGrowth: 'YoY Growth',
    neighborhoods: 'Neighborhoods',
    activeListings: 'Active Listings',
    priceEvolution: 'Average Price Evolution',
    since2020: '+54.5% since 2020',
    currentAvg: 'Current avg. (2025)',
    neighborhoodsTitle: 'Neighborhoods in Miami',
    neighborhoodsFound: '7 neighborhoods found',
    searchPlaceholder: 'Search neighborhoods...',
    sortPrice: 'Price',
    sortGrowth: 'Growth',
    sortAZ: 'A–Z',
    pricePerSqft: 'Avg. price per sq ft',
    yoyVar: 'YoY',
    walkability: 'Walkability',
    infrastructure: 'Infrastructure',
    appreciation: 'Appreciation',
    viewFullGuide: 'View Full Guide',
  },
  priceTable: {
    title: 'Full Price Comparison',
    subtitle: 'All neighborhoods ranked by average price per unit area',
    colNeighborhood: 'Neighborhood',
    colCity: 'City',
    colAvgPrice: 'Avg. Price',
    colYoY: 'YoY',
    colMarketType: 'Market Type',
    colListings: 'Listings',
  },
  compare: {
    title: 'Interactive Tool',
    subtitle: 'Compare markets side by side',
    description: 'Select two markets and compare prices, yield, investment scores, and ideal buyer profile.',
    marketA: 'Market A',
    marketB: 'Market B',
    metric: 'Metric',
    overview: 'Overview',
    returnYield: 'Return & Yield',
    investmentScores: 'Investment Scores (0–10)',
    overallScore: 'Overall Score',
    profileAnalysis: 'Profile & Analysis',
    strengths: 'Strengths',
    risks: 'Key Risks',
    viewAnalysis: 'View full neighborhood analysis',
    viewMiamiGuide: 'View Miami Guide',
    viewSPGuide: 'View São Paulo Guide',
    footerNote: 'Scores are editorial estimates based on public indices (FipeZAP, Zillow, Q1 2025). They do not constitute financial advice.',
    of10: 'out of 10',
    currency: 'Currency',
    entryPrice: 'Entry price (min.)',
    avgPrice: 'Average price',
    topMarket: 'Top of market',
    yoyAppreciation: 'YoY Appreciation',
    rentalYield: 'Rental Yield',
    recommendedHorizon: 'Recommended horizon',
    marketLiquidity: 'Market liquidity',
    appreciationPotential: 'Appreciation potential',
    passiveIncome: 'Passive income',
    idealProfile: 'Ideal investor profile',
    locationMiami: 'Florida, USA',
    locationSP: 'São Paulo, Brazil',
    currencyA: 'USD · US dollar',
    currencyB: 'BRL · Brazilian real',
    yieldA: '5–8% p.a.',
    yieldB: '4–6% p.a.',
    horizonA: '5–10 years',
    horizonB: '3–10 years',
    idealProfileA: 'International diversification, currency protection, and a long-term horizon (5–10 years)',
    idealProfileB: 'Maximum liquidity, neighborhood diversity, and exposure to Latin America\'s largest financial hub',
    strengthsA: ['0% FL state income tax', 'Short-term rental viable', 'International market', 'BRL/USD currency hedge', 'Cumulative appreciation +54% (5 years)'],
    strengthsB: ['Largest market in LATAM', 'Maximum liquidity', 'Diversity of neighborhoods and tiers', 'Faria Lima corporate hub'],
    risksA: ['Currency risk (BRL/USD)', 'High maintenance costs', 'Mandatory insurance (hurricanes)', 'Bureaucracy for non-residents'],
    risksB: ['ITBI + high tax burden', 'High supply in some neighborhoods', 'More gradual appreciation'],
  },
  country: {
    usa: 'USA',
    brazil: 'Brazil',
  },
  cta: {
    title: 'Ready to Invest in the Right Neighborhood?',
    specialist: 'Market Intelligence Specialist',
    description: 'Our specialists know every market inside out. Get personalized advice today.',
    whatsapp: 'Talk to an Expert on WhatsApp',
    browse: 'Browse All Listings',
  },
  spHighlight: {
    title: 'Itaim Bibi leads valuation in SP with +11.3% YoY in Q1 2026',
    subtitle: 'Faria Lima corridor maintains heated demand with new international fund offices in the region.',
  },
  brasiliaHighlight: {
    title: 'FipeZAP: DF leads appreciation among capitals with +12.6% in 2025',
    subtitle: 'Sudoeste and Noroeste drive the rise — average price in Plano Piloto reaches R$14,300/m².',
  },
  miamiHighlight: {
    title: 'Sunny Isles surpasses US$2,000/sq ft for the first time in history',
    subtitle: 'Bentley Residences and Porsche Design Tower raise the region\'s price floor to an all-time high.',
  },
  cityPages: {
    shared: {
      marketPulse: 'Market Pulse',
      updates: '3 updates',
      updatedOn: 'Updated on',
      disclaimerWarning: 'Disclaimer',
      disclaimerMiami: 'Price data are estimates based on public indices (CondoBlackBook, Zillow, Q1 2025). They do not constitute financial advice. Consult a professional before making any investment decision.',
      disclaimerBR: 'Price data are estimates based on public indices (FipeZAP, ZAP Imóveis, 2025). They do not constitute financial advice. Consult a professional before making any investment decision.',
      interactiveTool: 'Interactive Tool',
      compareHeading: 'Compare markets side by side',
      compareSubtitle: 'Select two markets and compare prices, yield, investment scores, and ideal buyer profile.',
      marketA: 'Market A',
      marketB: 'Market B',
      vs: 'VS',
      metric: 'Metric',
      overview: 'Overview',
      returnYield: 'Return & Yield',
      investmentScores: 'Investment Scores (0–10)',
      overallScore: 'Overall Score',
      profileAnalysis: 'Profile & Analysis',
      idealProfile: 'Ideal investor profile',
      strengths: 'Strengths',
      risks: 'Key risks',
      viewAnalysis: 'View full neighborhood analysis',
      footerNote: 'Scores are editorial estimates based on public indices (FipeZAP, Zillow, Q1 2025). They do not constitute financial advice.',
      of10: 'out of 10',
      currency: 'Currency',
      entryPrice: 'Entry price (min.)',
      avgPrice: 'Average price',
      topMarket: 'Top of market',
      yoyAppreciation: 'YoY appreciation',
      rentalYield: 'Rental yield',
      recommendedHorizon: 'Recommended horizon',
      marketLiquidity: 'Market liquidity',
      appreciationPotential: 'Appreciation potential',
      passiveIncome: 'Passive income',
      faqBadge: 'FAQ',
      viewAllFaqs: 'View all questions in the FAQ center',
      exploreBadge: 'Market Guide',
      exploreTitle: 'Explore other markets',
      exploreSubtitle: 'Detailed analysis of the top real estate investment destinations.',
      exploreViewAll: 'View all markets',
      avgPriceLabel: 'Average price',
      yoyLabel: 'YoY appreciation',
      viewFullGuide: 'View full guide',
      colRank: '#',
      colNeighborhood: 'Neighborhood',
      colPrice: 'Avg. price',
      colYoY: 'YoY',
      colProfile: 'Profile',
      colListings: 'Listings',
      hot: 'Hot',
      top: 'Top',
      currencyLabel: 'Currency',
      ctaWhatsapp: 'Talk to an expert now',
      falarConsultor: 'Talk to a consultant',
    },
    miami: {
      heroBadge: 'Miami · Florida',
      heroTitle: 'Best Neighborhoods in Miami',
      heroTitleHighlight: 'to Invest in 2025',
      heroDescription: 'Miami has established itself as the top real estate investment destination for Brazilians in the United States. With average prices above $1,000/sq ft, historic double-digit appreciation, and no state income tax, the city offers one of the best risk-adjusted returns in the world.',
      heroCtaProperties: 'View Miami properties',
      heroCtaContact: 'Talk to a consultant',
      location: 'Miami, FL',
      countryLabel: 'Florida, USA',
      currencyA: 'USD · US dollar',
      currencyB: 'BRL · Brazilian real',
      strengthsA: ['0% FL state income tax', 'Short-term rental viable', 'International market', 'BRL/USD currency hedge', 'Cumulative +54% appreciation (5 yrs)'],
      strengthsB: ['Largest market in LATAM', 'Maximum liquidity', 'Neighborhood & tier diversity', 'Faria Lima corporate hub'],
      risksA: ['Currency risk (BRL/USD)', 'High maintenance costs', 'Mandatory insurance (hurricanes)', 'Bureaucracy for non-residents'],
      risksB: ['ITBI + high tax burden', 'High supply in some areas', 'More gradual appreciation'],
      idealProfileA: 'International diversification, currency protection, and long-term horizon (5–10 years)',
      idealProfileB: 'Maximum liquidity, neighborhood diversity, and exposure to Latin America\'s largest financial hub',
      entryPriceA: 'US$ 400,000',
      entryPriceB: 'R$ 350,000',
      avgPriceA: 'US$ 1,100/sq ft',
      avgPriceB: 'R$ 11,800/m²',
      topMarketA: 'US$ 3,800/sq ft · Bal Harbour',
      topMarketB: 'R$ 32,000/m² · Cidade Jardim',
      yieldA: '5–8% p.a.',
      yieldB: '4–6% p.a.',
      horizonA: '5–10 years',
      horizonB: '3–10 years',
      liquidityA: '9.2',
      liquidityB: '10.0',
      appreciationA: '9.0',
      appreciationB: '7.0',
      passiveIncomeA: '8.0',
      passiveIncomeB: '7.0',
      overallScoreA: '8.7',
      overallScoreB: '8.0',
      scoreWidthA: '87%',
      scoreWidthB: '80%',
      viewGuideA: 'View Miami guide',
      viewGuideB: 'View São Paulo guide',
      whyInvestTitle: 'Why invest in Miami?',
      whyInvestSubtitle: '4 reasons that make Miami the top real estate investment destination for Brazilians in the US.',
      neighborhoodsTitle: 'Miami Neighborhoods — Full Analysis',
      neighborhoodsSubtitle: 'Click any neighborhood to see detailed prices, scores, and market highlights.',
      rankingTitle: 'Price Ranking — Miami Neighborhoods',
      rankingSubtitle: 'Comparison sorted by average price per sq ft · Q1 2025',
      howToBuyBadge: 'Guide for Brazilians',
      howToBuyTitle: 'How to buy property in Miami as a Brazilian',
      howToBuySubtitle: 'Step-by-step guide for Brazilian investors to acquire US real estate with legal security and tax efficiency.',
      howToBuyHelpTitle: 'Need help with this whole process?',
      howToBuyHelpSubtitle: 'Our team guides Brazilians from ITIN to key delivery — at no additional cost.',
      howToBuyHelpCTA: 'Talk to a specialist',
      faqTitle: 'Questions about investing in Miami',
      faqSubtitle: 'Top questions from Brazilian investors about buying property in Miami — answered by specialists.',
      exploreCardBrasiliaTitle: 'Brasília',
      exploreCardBrasiliaSubtitle: 'Federal capital with the highest per capita income in Brazil, UNESCO heritage, and a resilient market.',
      exploreCardBrasiliaBadge: 'Federal District',
      exploreCardBrasiliaPrice: 'R$12,000/m²',
      exploreCardBrasiliaYoY: '+12.6%',
      exploreCardBrasiliaYoYLabel: 'Highest rise of the year',
      exploreCardSPTitle: 'São Paulo',
      exploreCardSPSubtitle: 'Largest real estate market in Latin America. Faria Lima, Itaim Bibi, and the continuous appreciation corridor.',
      exploreCardSPBadge: 'São Paulo, Brazil',
      exploreCardSPPrice: 'R$11,800/m²',
      exploreCardSPYoY: '+8.7%',
      exploreCardSPYoYLabel: 'YoY appreciation',
      ctaTitle: 'Ready to invest in Miami?',
      ctaSubtitle: 'Our team specialized in Miami real estate has been serving Brazilians for over 9 years. From ITIN to key delivery.',
      ctaSecondary: 'View Miami properties',
    },
    saoPaulo: {
      heroBadge: 'São Paulo · SP',
      heroTitle: 'Best Neighborhoods in São Paulo',
      heroTitleHighlight: 'to Invest in 2025',
      heroDescription: 'São Paulo is Brazil\'s financial capital and the largest real estate market in Latin America. With over 12 million inhabitants, a GDP equivalent to entire countries, and average appreciation of +8.7% in 2025, the city offers unique opportunities for investors seeking income, appreciation, or portfolio diversification.',
      heroCtaProperties: 'View São Paulo properties',
      heroCtaContact: 'Talk to a consultant',
      location: 'São Paulo, SP',
      countryLabel: 'São Paulo, Brazil',
      currencyA: 'BRL · Brazilian real',
      currencyB: 'USD · US dollar',
      strengthsA: ['Largest market in LATAM', 'Maximum liquidity', 'Neighborhood & tier diversity', 'Faria Lima corporate hub'],
      strengthsB: ['0% FL state income tax', 'Short-term rental viable', 'International market', 'BRL/USD currency hedge', 'Cumulative +54% appreciation (5 yrs)'],
      risksA: ['ITBI + high tax burden', 'High supply in some areas', 'More gradual appreciation'],
      risksB: ['Currency risk (BRL/USD)', 'High maintenance costs', 'Mandatory insurance (hurricanes)', 'Bureaucracy for non-residents'],
      idealProfileA: 'Maximum liquidity, neighborhood diversity, and exposure to Latin America\'s largest financial hub',
      idealProfileB: 'International diversification, currency protection, and long-term horizon (5–10 years)',
      entryPriceA: 'R$ 350,000',
      entryPriceB: 'US$ 400,000',
      avgPriceA: 'R$ 11,800/m²',
      avgPriceB: 'US$ 1,100/sq ft',
      topMarketA: 'R$ 32,000/m² · Cidade Jardim',
      topMarketB: 'US$ 3,800/sq ft · Bal Harbour',
      yieldA: '4–6% p.a.',
      yieldB: '5–8% p.a.',
      horizonA: '3–10 years',
      horizonB: '5–10 years',
      liquidityA: '10.0',
      liquidityB: '9.2',
      appreciationA: '7.0',
      appreciationB: '9.0',
      passiveIncomeA: '7.0',
      passiveIncomeB: '8.0',
      overallScoreA: '8.0',
      overallScoreB: '8.7',
      scoreWidthA: '80%',
      scoreWidthB: '87%',
      viewGuideA: 'View São Paulo guide',
      viewGuideB: 'View Miami guide',
      whyInvestTitle: 'Why invest in São Paulo?',
      whyInvestSubtitle: '4 reasons that make São Paulo the largest real estate investment destination in Latin America.',
      neighborhoodsTitle: 'São Paulo Neighborhoods — Full Analysis',
      neighborhoodsSubtitle: 'Click any neighborhood to see detailed prices, scores, and market profile.',
      rankingTitle: 'Price Ranking — São Paulo Neighborhoods',
      rankingSubtitle: 'Comparison sorted by average price per m² · 2025',
      faqTitle: 'Questions about São Paulo real estate',
      faqSubtitle: 'Top questions from buyers and investors about the largest real estate market in Latin America.',
      exploreCardMiamiTitle: 'Miami',
      exploreCardMiamiSubtitle: 'The top destination for Brazilians in the US — strong dollar, high yield, and international market.',
      exploreCardMiamiBadge: 'Florida, USA',
      exploreCardMiamiPrice: '$1,100/sq ft',
      exploreCardMiamiYoY: '+18%',
      exploreCardMiamiYoYLabel: 'YoY appreciation',
      exploreCardBrasiliaTitle: 'Brasília',
      exploreCardBrasiliaSubtitle: 'Federal capital with the highest per capita income in Brazil, UNESCO heritage, and a resilient market.',
      exploreCardBrasiliaBadge: 'Federal District',
      exploreCardBrasiliaPrice: 'R$12,000/m²',
      exploreCardBrasiliaYoY: '+12.6%',
      exploreCardBrasiliaYoYLabel: 'Highest rise of the year',
      ctaTitle: 'Ready to invest in São Paulo?',
      ctaSubtitle: 'Our team specialized in the São Paulo market guides you from neighborhood selection to contract signing — at no additional cost.',
      ctaSecondary: 'View São Paulo properties',
    },
    brasilia: {
      heroBadge: 'Brasília · Federal District',
      heroTitle: 'Best Neighborhoods in Brasília',
      heroTitleHighlight: 'to Buy Property in 2025',
      heroDescription: 'Brasília recorded 12.6% growth in new property prices in 2025 — the highest among Brazilian capitals. The federal capital with one of the highest per capita incomes in Brazil, stable public-sector demand, and naturally restricted supply due to urban heritage protection makes the city one of the most resilient markets in the country.',
      heroCtaProperties: 'View Brasília properties',
      heroCtaContact: 'Talk to a consultant',
      location: 'Brasília, DF',
      countryLabel: 'Federal District, Brazil',
      currencyA: 'BRL · Brazilian real',
      currencyB: 'BRL · Brazilian real',
      strengthsA: ['UNESCO-limited supply', 'Highest per capita income in BR', 'Stable public-sector demand', 'Crisis-resilient market'],
      strengthsB: ['Largest market in LATAM', 'Maximum liquidity', 'Neighborhood & tier diversity', 'Faria Lima corporate hub'],
      risksA: ['More regional liquidity', 'Dependence on federal budgets', 'Less diversified market'],
      risksB: ['ITBI + high tax burden', 'High supply in some areas', 'More gradual appreciation'],
      idealProfileA: 'Conservative profile seeking asset security and stable public-servant rental income',
      idealProfileB: 'Maximum liquidity, neighborhood diversity, and exposure to Latin America\'s largest financial hub',
      entryPriceA: 'R$ 450,000',
      entryPriceB: 'R$ 350,000',
      avgPriceA: 'R$ 12,000/m²',
      avgPriceB: 'R$ 11,800/m²',
      topMarketA: 'R$ 16,500/m² · Sudoeste',
      topMarketB: 'R$ 32,000/m² · Cidade Jardim',
      yieldA: '~5% p.a.',
      yieldB: '4–6% p.a.',
      horizonA: '3–7 years',
      horizonB: '3–10 years',
      liquidityA: '7.0',
      liquidityB: '10.0',
      appreciationA: '8.0',
      appreciationB: '7.0',
      passiveIncomeA: '7.0',
      passiveIncomeB: '7.0',
      overallScoreA: '7.3',
      overallScoreB: '8.0',
      scoreWidthA: '73%',
      scoreWidthB: '80%',
      viewGuideA: 'View Brasília guide',
      viewGuideB: 'View São Paulo guide',
      whyInvestTitle: 'Why invest in Brasília?',
      whyInvestSubtitle: '4 structural factors that make Brasília one of the most resilient real estate markets in Brazil.',
      neighborhoodsTitle: 'Brasília Neighborhoods — Full Analysis',
      neighborhoodsSubtitle: 'Click any neighborhood to see detailed prices, scores, and market profile.',
      rankingTitle: 'Price Ranking — Brasília Neighborhoods',
      rankingSubtitle: 'Comparison sorted by average price per m² · 2025',
      faqTitle: 'Questions about Brasília real estate',
      faqSubtitle: 'Top questions from buyers and investors about the Brasília and Federal District real estate market.',
      exploreCardMiamiTitle: 'Miami',
      exploreCardMiamiSubtitle: 'The top destination for Brazilians in the US — strong dollar, high yield, and international market.',
      exploreCardMiamiBadge: 'Florida, USA',
      exploreCardMiamiPrice: '$1,100/sq ft',
      exploreCardMiamiYoY: '+18%',
      exploreCardMiamiYoYLabel: 'YoY appreciation',
      exploreCardSPTitle: 'São Paulo',
      exploreCardSPSubtitle: 'Largest real estate market in Latin America. Faria Lima, Itaim Bibi, and the continuous appreciation corridor.',
      exploreCardSPBadge: 'São Paulo, Brazil',
      exploreCardSPPrice: 'R$11,800/m²',
      exploreCardSPYoY: '+8.7%',
      exploreCardSPYoYLabel: 'YoY appreciation',
      ctaTitle: 'Ready to invest in Brasília?',
      ctaSubtitle: 'Our team specialized in the Federal District market guides you from neighborhood selection to contract signing — at no additional cost.',
      ctaSecondary: 'View Brasília properties',
    },
  },
};

export default guia;